import { ChangeDetectionStrategy, Component, OnDestroy, OnInit } from '@angular/core';
import { isIFrameSameOrigin } from '../../shared/helpers/is-same-origin';
import QueryParamsUtils from '../../shared/helpers/query-params-utils';
import { serializeParams } from '../../shared/helpers/serialize-params';
import { OeAppPersonService } from '../../shared/oe-app-person.service';
import { OeAppService } from '../../shared/oe-app.service';
import { WindowService } from '../../shared/window.service';

export enum UnitIndexEventType {
  OPEN_LESSON = 'OpenLessonEvent',
  NEXT_LESSON = 'NextLessonEvent',
}

@Component({
  selector: 'lp2-unit-index-page',
  templateUrl: './unit-index-page.component.html',
  styleUrls: ['./unit-index-page.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class UnitIndexPageComponent implements OnInit, OnDestroy {
  public unitIndexFrameUrl: string;

  constructor(
    private oeApp: OeAppService,
    private oeAppPersonService: OeAppPersonService,
    private windowService: WindowService
  ) {}

  ngOnInit() {
    this.unitIndexFrameUrl =
      `${this.oeApp.webUnitIndexHost}` +
      `?personId=${this.oeAppPersonService.id}` +
      `&contactId=${this.oeAppPersonService.contactId}` +
      `&lang=${this.oeAppPersonService.preferredLang}` +
      `&env=${this.oeApp.environment}`;
    window.addEventListener('message', this.handleEvents.bind(this), false);
  }

  ngOnDestroy() {
    window.removeEventListener('message', this.handleEvents);
  }

  public handleEvents({ data, origin }) {
    if (!isIFrameSameOrigin(this.oeApp.webUnitIndexHost, origin)) {
      return;
    }

    const type: UnitIndexEventType = data.type;
    switch (type) {
      case UnitIndexEventType.OPEN_LESSON:
        const { level, lesson, unit } = data.data;
        const serializedParams = serializeParams({
          levelName: level.name,
          unitId: unit.id,
          unitName: unit.name,
          courseId: lesson.id,
          isFromUnitIndex: true,
        });
        this.openLesson(serializedParams);
        break;
      case UnitIndexEventType.NEXT_LESSON:
        this.openNextLesson();
        break;
      default:
        console.error('Event type not handled: ', data);
        break;
    }
  }

  private openNextLesson() {
    this.windowService.redirectToHref('/learning/lesson.html');
  }

  private openLesson(serializedParams: string) {
    const params = QueryParamsUtils.hashQueryParams(serializedParams);
    this.windowService.redirectToHref(`/learning/lesson.html?q=${params}`);
  }
}



// WEBPACK FOOTER //
// ./ts/app/unit-index/unit-index-page/unit-index-page.component.ts